<template>
	<div class="emailHost">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<el-row type="flex" class="row-bg" justify="space-between">
			<el-button type="primary" @click="add">新增</el-button>
		</el-row>
		<data-list
			:data="data"
			:columns="column"
			:page="page"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
		></data-list>

		<!-- 编辑表单 -->
		<emailHostForm ref="emailHostForm" dialogWidth="400px" :title="title"></emailHostForm>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import emailHostForm from './components/emailHostForm.vue';
import emailHostSer from '@/backend/services/emailHost/emailHostSer.js';

const list = listPageCreate({
	searchConfig: {
		api: api.emailHost.emailHostList,
		method: 'POST',
	},
});

export default {
	name: 'emailHost',
	props: [],
	components: {
		filterPanel,
		emailHostForm,
	},
	mixins: [list],
	data() {
		let that = this;
		return {
			title: '新增邮箱host配置',
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '请输入域名',
						label: '域名',
						prop: 'emailDomain',
					},
					{
						tagName: 'sky-input',
						placeholder: '请输入收邮件服务器',
						label: '收邮件服务器',
						prop: 'imapHost',
					},
					{
						tagName: 'sky-input',
						placeholder: '请输入发邮件服务器',
						label: '发邮件服务器',
						prop: 'smtpHost',
					},
				],
			},
			column: [
				{
					label: '域名',
					bind: 'emailDomain',
				},
				{
					label: '收邮件服务器',
					bind: 'imapHost',
				},
				{
					label: '发邮件服务器',
					bind: 'smtpHost',
				},
				{
					label: '收件箱',
					bind: 'inbox',
				},
				{
					label: '已发送',
					bind: 'sent',
				},
				{
					label: '已删除邮件',
					bind: 'deleteMail',
				},
				{
					label: '垃圾邮件',
					bind: 'junkMail',
				},
				{
					label: '操作',
					type: 'btnClick',
					align: 'center',
					width: 230,
					bind: () => {
						return [
							{
								text: '编辑',
								trigger: async row => {
									this.title = '编辑邮箱host配置';
									let { cancel } = await this.$refs.emailHostForm.show(row);
									if (!cancel) {
										that.query();
									}
								},
							},
							{
								text: '删除',
								trigger: row => {
									this.del(row);
								},
							},
						];
					},
				},
			],
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.query();
	},
	methods: {
		async add() {
			this.title = '新增邮箱host配置';
			let { cancel } = await this.$refs.emailHostForm.show();
			if (!cancel) {
				this.query();
			}
		},
		del(row) {
			let { id } = row;
			this.$confirm(`确定删除此配置信息？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'danger',
			}).then(async () => {
				try {
					await emailHostSer.emailHostDel({
						id,
					});
					this.$message.success('删除成功');
          this.query();
				} catch (error) {
					console.log(error);
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.emailHost {
}
</style>
